"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNullableMood = exports.assertMood = exports.MOOD = void 0;
var Mood;
(function (Mood) {
    Mood["HAPPY"] = "HAPPY";
    Mood["OKAY"] = "OKAY";
    Mood["SAD"] = "SAD";
})(Mood || (Mood = {}));
exports.MOOD = Object.values(Mood);
function assertMood(value) {
    if (value !== Mood.HAPPY && value !== Mood.OKAY && value !== Mood.SAD) {
        throw Object.assign(new Error(`Invalid mood: ${value}`), { status: 400 });
    }
    return value;
}
exports.assertMood = assertMood;
function assertNullableMood(value) {
    return value === null ? null : assertMood(value);
}
exports.assertNullableMood = assertNullableMood;
exports.default = Mood;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9vZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9Nb29kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQUssSUFJSjtBQUpELFdBQUssSUFBSTtJQUNQLHVCQUFlLENBQUE7SUFDZixxQkFBYSxDQUFBO0lBQ2IsbUJBQVcsQ0FBQTtBQUNiLENBQUMsRUFKSSxJQUFJLEtBQUosSUFBSSxRQUlSO0FBRVksUUFBQSxJQUFJLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztBQUV4QyxTQUFnQixVQUFVLENBQUMsS0FBYztJQUN2QyxJQUFJLEtBQUssS0FBSyxJQUFJLENBQUMsS0FBSyxJQUFJLEtBQUssS0FBSyxJQUFJLENBQUMsSUFBSSxJQUFJLEtBQUssS0FBSyxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQ3JFLE1BQU0sTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLEtBQUssQ0FBQyxpQkFBaUIsS0FBSyxFQUFFLENBQUMsRUFBRSxFQUFFLE1BQU0sRUFBRSxHQUFHLEVBQUUsQ0FBQyxDQUFDO0tBQzNFO0lBQ0QsT0FBTyxLQUFhLENBQUM7QUFDdkIsQ0FBQztBQUxELGdDQUtDO0FBRUQsU0FBZ0Isa0JBQWtCLENBQUMsS0FBYztJQUMvQyxPQUFPLEtBQUssS0FBSyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ25ELENBQUM7QUFGRCxnREFFQztBQUVELGtCQUFlLElBQUksQ0FBQyJ9